import type { FaireProductEntity } from "../../entity_types/product";

export const p_pezvxyedpg: FaireProductEntity = {
  token: "p_pezvxyedpg",
  type: "product",
  name: "Balloon Dog Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b175723a398fb68cddea47e658a75dd23acf2296e9e82b86d5d1e63ea90a2faf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b44ce62d5eb3ec3cc2feddaaaf977608959aa4cb58b3a23e898bc409e59bd93b.jpeg",
    "https://cdn.faire.com/fastly/a51b873a74f678363c5de93cbd7725c12226cb52f8884d72d519e848c32490d7.png",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:16.848Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
